import { useState } from "react";

export const useValidationBlur = () => {
  const [shouldValidate, setShouldValidate] = useState(false);

  const onBlur = () => {
    setShouldValidate(true);
  };

  return {
    shouldValidate,
    onBlur,
  };
};
